import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {useSelector, useDispatch} from 'react-redux';
import {selectModal, dismissModal} from '~/slices/modalSlice';

import ModalComponentSwitcher from '~/components/ModalComponentSwitcher';
import DropSideCard from '~/components/DropSideCard';

import * as ModalConstants from '~/constants/ModalConstants';
import InkMatchModal from './InkMatchModal';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
const ModalContainer = ({isMobile, onHide = () => {}, onShow = () => {}}) => {
  const {key, ...modalProps} = useSelector(selectModal);
  const dispatch = useDispatch();

  // app_lg needs these callbacks so that the page underneath doesn't scroll
  useEffect(() => {
    if (key) {
      onShow(true);
    }
  }, [key, onShow]);

  const close = () => {
    onHide(true);
    dispatch(dismissModal());
  };

  return (
    <ModalComponentSwitcher
      currentKey={key}
      // All props other than currentKey passed to all children
      open={!!key}
      onClose={close}
      isMobile={isMobile}
      {...modalProps}>
      <DropSideCard name={ModalConstants.DROP_SIDE_SAVE_MONEY} />
      <InkMatchModal name={ModalConstants.INK_MATCH_MODAL} />
    </ModalComponentSwitcher>
  );
};

const propTypes = {
  isMobile: PropTypes.bool,
  onHide: PropTypes.func,
  onShow: PropTypes.func
};

ModalContainer.propTypes = propTypes;

export const ModalPropTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func
};

export default ModalContainer;
